import http from "./Interceptor";
import axios from "axios";
const BASEURL = "/api";

const getRequestErrorMessage = (err) => {
	const status = err?.response?.status;
	const data = err?.response?.data;

	if (data?.message) return data.message;
	if (typeof data === "string" && data.trim()) return data;
	if (status === 413 || status === 513) {
		return "Le fichier est trop volumineux. La taille maximale autorisee est de 10 Mo.";
	}

	return "Une erreur inattendue est survenue.";
};

export const LoginRequest = (username,password, onSuccess, onResponse) =>{
	if (username && password) {
		http
			.post(BASEURL + `/login/`,{username:username,password:password})
			.then(res => {res.status.toString() === "200"?onSuccess(res):onResponse(res)})
			.catch(() => onResponse());
	}
};
// export const CreateUserRequest = (onSuccess, onResponse) =>{
// 		http
// 			.post(BASEURL + `/user/create`,{})
// 			.then(res => onSuccess(res))
// 			.catch(() => onResponse());
// };
export const getCountOfAccounts= (onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/user/getstatsaccounts`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}



export const CreateEvenementRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/evenement/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const updateEvenementRequest = (data,updatedData, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/evenement/update`,{data:data,updatedData:updatedData})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const getEvenementHomeRequest = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/evenements/gethome`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getLastIncomingEvents = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/evenements/get/avenir/list`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getLastExternalEvents = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/evenements/get/external/list`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};


export const getEvenementAvenirRequest = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/evenements/get/avenir`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getEvenementAvenirMemberRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/ca/evenement/get/avenir`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const getEvenementPasseRequest = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/evenements/get/passe`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getEvenementPasseMemberRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/ca/evenement/get/passe`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getEvenementExternalMemberRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/ca/evenement/get/external`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getEvenementExternalRequest = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/evenements/get/external`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};


export const getPartenaireRequest = (onSuccess, onResponse) => {
	http
		.get(BASEURL + `/partenaire/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

// export const subscribeEvenementRequest = (data, onSuccess, onResponse) =>{
// 	var sessionJWT = sessionStorage.getItem("jwttoken");


// 	if (sessionJWT) {
// 		axios.defaults.headers.common["jwtToken"] = sessionJWT;
// 		http
// 		.post(BASEURL + `/ca/evenement/subscribe`,{data:data})
// 		.then(res => onSuccess(res))
// 		.catch(() => onResponse());
// 	}else{
// 		onResponse()
// 	}
	
// };
// export const unsubscribeEvenementRequest = (data, onSuccess, onResponse) =>{
// 	var sessionJWT = sessionStorage.getItem("jwttoken");


// 	if (sessionJWT) {
// 		axios.defaults.headers.common["jwtToken"] = sessionJWT;
// 		http
// 		.post(BASEURL + `/ca/evenement/unsubscribe`,{data:data})
// 		.then(res => onSuccess(res))
// 		.catch(() => onResponse());
// 	}else{
// 		onResponse()
// 	}
	
// };

export const getAllEvenementRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/evenement/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const getAllMembersRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/user/getall`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const getAllMembersByRoleRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/ca/user/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const deleteMemberRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/user/remove`,{member_id:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const createMemberRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/user/create`,{data: data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const resetPasswordRequest = (data, onSuccess, onResponse) => {
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/user/resetpassword`,{data: data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const getTokenRequest = (data, onSuccess, onResponse) => {

	http
		.post(BASEURL + `/user/token`,{data: data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const forgotPasswordRequest = (identifier, onSuccess, onResponse) => {
	http
		.post(BASEURL + `/user/forgot-password`, { identifier })
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const getTokenResetRequest = (data, onSuccess, onResponse) => {

	http
		.post(BASEURL + `/user/reset`,{data: data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};



export const updateMemberRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/user/update`,{data: data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};


export const updateMemberPasswordRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/user/update/password`,{data: data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};




export const deleteEvenementRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/evenement/remove`,{evenement_id:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const CreateProgRequest = (data, onSuccess, onResponse) =>{
	http
		.post(BASEURL + `/admin/evenement/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};


// CATEGORIES

export const getGalerieCategoriesRequest = (onSuccess, onResponse) =>{
	http
		.get(BASEURL + `/galerycategories/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getGalerieCategoriesAdminRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/galerycategories/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const deleteGalerieCategoryRequest = (data,onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerycategories/remove`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const createGalerieCategoryRequest = (data,onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerycategories/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const swapGalerieCategoriesOrderRequest = (data,onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerycategories/swap`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};


export const createPublicGalerieRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerie/public/create`, {data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const createMemberGalerieRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");
	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerie/create`, {data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
};
export const deletePublicImageRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerie/public/delete`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const deleteMemberImageRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/galerie/delete`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};
export const getMembersGalerieRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/ca/galerie/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};

export const getAllGalerieRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/ca/galerie/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};


export const getPublicGalerieRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/galerie/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
};



// ADHESION //
export const removeAdhesionByIdRequest = (data, onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/adhesion/remove`,{data: data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const getAllAdhesionRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/adhesion/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}


// PARTENAIRES //

export const getAllPartenairesRequest = (onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/partenaire/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

export const removePartenaireByIdRequest = (data,onSuccess, onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/partenaire/remove`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const createPartenaireRequest = (data,onSuccess, onResponse)=>{
		var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/partenaire/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}
export const getPartenairesRequest = (onSuccess, onResponse)=>{
	http
		.get(BASEURL + `/partenaire/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

// TROMBINOSCOPE //

export const createTrombinoscopeRequest = (data,onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/trombinoscope/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}

export const getAllTrombinoscopeRequest = (onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/trombinoscope/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const removeTrombinoscopeRequest = (data,onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/trombinoscope/remove`,data)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const getTrombinoscopeRequest = (onSuccess, onResponse)=>{
	http
		.get(BASEURL + `/trombinoscope/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}


// ADHESION //

export const createAdhesionRequest = (data, onSuccess, onResponse)=>{
	http
		.post(BASEURL + `/adhesion/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}

export const getAdhesionRequest = (onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/adhesion/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

export const removeAdhesionRequest = (data, onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/adhesion/remove`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const getAdhesionNotifRequest = (onSuccess, onResponse)=>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/adhesion/notif`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

// QUI SOMMES-NOUS? //

export const CreateQsnRequest = (data,onSuccess,onResponse) =>{
		var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/qsn/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}

export const getAllQsnRequest = (onSuccess,onResponse) =>{

	http
		.get(BASEURL + `/qsn/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

export const removeQsnRequest = (data,onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/qsn/remove`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

// Visitor Tracker 
export const visitorTrackerRequest = (data,onSuccess,onResponse) => {
	http
		.post(BASEURL + `/tracker/add`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const getAllStatistiques = (onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/tracker/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const getAllConnexionStatistiques = (onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/tracker/get_connexion`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}


// SERVER USAGE

export const getServerStatistiques = (onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/tracker/server/usage`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

// EPHEMERIDE 
export const getEphemeride = (onSuccess,onResponse) =>{
	http
		.get(BASEURL + `/ephemeride/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

// CA REPO


export const getCADocuments = (onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/carepo/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const uploadCADocument = (data,onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/carepo/create`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}
export const deleteCADocument = (data,onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/carepo/remove`,{data:data})
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}
export const getCADocumentsMembers = (onSuccess,onResponse) =>{
	http
		.get(BASEURL + `/ca/carepo/get`)
		.then(res => onSuccess(res))
		.catch(() => onResponse());
}

/* ====LINK GENERATION====  */
export const uploadDocumentLink = (data,onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");
	const formData = new FormData();

	formData.append("name", data.name);
	formData.append("file", data.file, data.file.name);

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/file/create`, formData)
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}
export const deleteDocumentLink = (data,onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.post(BASEURL + `/admin/file/remove`,{data:data})
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}
export const getDocumentLink = (onSuccess,onResponse) =>{
	var sessionJWT = sessionStorage.getItem("jwttoken");

	if (sessionJWT) {
		axios.defaults.headers.common["jwtToken"] = sessionJWT;
	}
	http
		.get(BASEURL + `/admin/file/get`)
		.then(res => onSuccess(res))
		.catch((err) => onResponse(getRequestErrorMessage(err)));
}



export const renameGalerieCategoryRequest = (data, onSuccess, onResponse) => {
  const sessionJWT = sessionStorage.getItem("jwttoken");
  if (sessionJWT) axios.defaults.headers.common["jwtToken"] = sessionJWT;
  http.post(BASEURL + "/admin/galerycategories/rename", { data })
    .then(onSuccess)
    .catch((err) => onResponse(getRequestErrorMessage(err)));
};

export const reorderGalerieImagesRequest = (data, onSuccess, onResponse) => {
  const token = sessionStorage.getItem("jwttoken");
  if (token) axios.defaults.headers.common["jwtToken"] = token;
  http.post(BASEURL + '/admin/galerie/reorder', { data })
    .then(onSuccess)
    .catch(error => onResponse(getRequestErrorMessage(error)));
};
